module.exports = __webpack_public_path__ + "sprstatic/img/baohanwen.025f39f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/baohanwen.png
// module id = BL6u
// module chunks = 2